module.exports = __webpack_public_path__ + "img/kislovodsk-places.662dd889.jpg";